/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */




$( document ).ready(function() {
jQuery('#notify-me').click(function() {

jQuery('#notify-me-wrapper').fadeIn();

return false;
} );
   

});


var selectCallback = function(variant, selector) {
    if (variant) {
      if (variant.available) {
        jQuery('#add-item-to-cart').removeAttr('disabled').removeClass('disabled').val('Pre-order Box');
      } else {
        jQuery('#add-item-to-cart').val('Sold Out').addClass('disabled').addAttr('disabled', 'disabled');

      }
    }
}
      

    
jQuery(".HorizontalList__Item").click(function(){
    var a = jQuery(this).find(jQuery("label")).text();
    jQuery(this).find(jQuery("input")).val(a);
})



jQuery(".SizeSwatchList .HorizontalList__Item.end label").click(function(){
   	var index = jQuery(this).parent().data("number");
  	if($(this).hasClass("active")){
		$(this).parent().removeClass("active");
      	$(".sold_out_variant:eq("+index+")").removeClass("active");
      	$(".sold_out_variant:eq("+index+")").find($("input")).val();
      	
    }else{
		$(".sold_out_variant").removeClass("active");
      	$(".sold_out_variant").find($("input")).val();
      	$(this).parent().addClass("active");
      	$(".sold_out_variant:eq("+index+")").addClass("active");
      	
	}
   	
})

jQuery(".SizeSwatchList .HorizontalList__Item.stock label").click(function(){
  $(".sold_out_variant").removeClass("active");
})
